import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import { isNil } from "lodash-es";

const moment = getMomentTz();

export const formatProductionDate = (
  productionDate: Date | string | undefined | null,
): string => {
  if (isNil(productionDate)) return "";

  return moment.utc(productionDate).format("MM-DD-YYYY");
};

export const ShortDateTimeFormat = (
  datetime: Date | string | undefined | null,
) => {
  return dxtToLocalServerTime(datetime, "MM/dd/yy HH:mm");
};
export const getTimeFormatFromUTC = (
  date: Date | string | null,
  format = "HH:mm",
) => {
  if (isNil(date)) return "";

  if (typeof date === "string") {
    if (date.includes("Z")) {
      return dxtToLocalServerTime(date, "HH:mm");
    } else {
      return dxtToLocalServerTime(`${date}Z`, "HH:mm");
    }
  }
  return dxtToLocalServerTime(`${date}Z`, "HH:mm");
};

export const decimalToTime = (decimalMinutes: number | undefined): string => {
  const minutes = Math.floor(decimalMinutes ?? 0);
  const seconds = Math.round(((decimalMinutes ?? 0) - minutes) * 60);
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");
  return `${formattedMinutes}:${formattedSeconds}`;
};

export const secondsToDate = (totalSeconds: number): Date => {
  const date = new Date(0); // Initialize with a zero date
  date.setSeconds(totalSeconds);
  return date;
};
